import { render, staticRenderFns } from "./FriendCreateDialog.vue?vue&type=template&id=05dcfc22&scoped=true&"
import script from "./FriendCreateDialog.vue?vue&type=script&lang=js&"
export * from "./FriendCreateDialog.vue?vue&type=script&lang=js&"
import style0 from "./FriendCreateDialog.vue?vue&type=style&index=0&id=05dcfc22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dcfc22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05dcfc22')) {
      api.createRecord('05dcfc22', component.options)
    } else {
      api.reload('05dcfc22', component.options)
    }
    module.hot.accept("./FriendCreateDialog.vue?vue&type=template&id=05dcfc22&scoped=true&", function () {
      api.rerender('05dcfc22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/彈窗/FriendCreateDialog.vue"
export default component.exports